import { render, staticRenderFns } from "./SalonSetting.vue?vue&type=template&id=11676356&"
import script from "./SalonSetting.vue?vue&type=script&lang=js&"
export * from "./SalonSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports